import { LinkOutlined } from "@ant-design/icons";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  Button,
  Checkbox,
  Dropdown,
  Image,
  Input,
  List,
  Menu,
  Pagination,
  Skeleton,
  Tooltip,
  message,
} from "antd";
import { isEmpty, isUndefined } from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  GET_ALL_LOCATIONS,
  GET_GENERIC_FILTERS,
  GET_GENERIC_FILTER_TYPES,
  GET_LOCATION_VEHICLE_INVENTORY,
} from "../../../graphql/query";
import { closeDialog } from "../../../library/helpers";
import DialogFooter from "../../commonComponents/dialogFooter";
import {
  CREATE_GENERIC_FILTER,
  CREATE_VDP_LINK_INVENTORY,
  UPDATE_GENERIC_FILTER,
} from "../../../graphql/mutation";
import { currencies } from "../../../library/constants";
import { formatPrice, getHighlightedText } from "../../../library/utils";
import useLang from "../../../hooks/useLang";
import { UserContext } from "../../../amplify/authenticator-provider";
import "./vdpSelector.css";

export default function VDPSelector(props) {
  const [lang] = useLang();
  const { text, setmessageText, handleInsertLink = () => {} } = props;
  const { textMode } = useSelector(state => state.lead);
  const [selectedVehicle, setselectedVehicle] = useState([]);
  const [search, setsearch] = useState("");
  const [pagination, setPagination] = useState({ page: 1, pageSize: 50 });
  const { user } = useContext(UserContext);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [genericFilterDataValues, seGenericFilterDataValues] = useState([]);
  const selectedCount = selectedLocations?.filter(loc => loc.isChecked).length;
  const [genericFilterTypesData, setGenericFilterTypesData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const [updateGenericFilter] = useMutation(UPDATE_GENERIC_FILTER);
  const [createGenericFilter] = useMutation(CREATE_GENERIC_FILTER);
  const [getVehicleInventory, { data: vdpData, loading: vdpLoader }] = useLazyQuery(
    GET_LOCATION_VEHICLE_INVENTORY,
    {
      fetchPolicy: "cache-and-network",
    }
  );

  const [getGenericFilterTypes, { loading: genericFilterTypeLoader }] = useLazyQuery(
    GET_GENERIC_FILTER_TYPES,
    {
      fetchPolicy: "cache-first",
    }
  );

  const [getGenericFilters, { loading: genericFilterLoader }] = useLazyQuery(GET_GENERIC_FILTERS, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (selectedLocations?.length > 0) {
      getVehicleInventory({
        variables: {
          currentLocationId: sessionStorage.getItem("currentLocationId"),
          locationIds: selectedLocations?.every(item => item.isChecked === true)
            ? []
            : selectedLocations.filter(item => item.isChecked).map(item => item.id),
          isAllLocations: selectedLocations?.every(item => item.isChecked === true),
          search,
          page: pagination.page,
          pageSize: pagination.pageSize,
        },
      });
    }
  }, [selectedLocations, search, pagination]);

  const { data: resp, loading: allLocationLoader } = useQuery(GET_ALL_LOCATIONS, {
    variables: {
      companyId: +user?.company?.id,
    },
    onCompleted: async res => {
      const temp = Array.isArray(res?.getAllLocations) ? [...res.getAllLocations] : [];
      temp.unshift({ id: 0, title: "All" });
      const genericFilterTypes = await getGenericFilterTypes();
      if ((genericFilterTypes?.data?.getGenericFilterTypes || []).length > 0) {
        setGenericFilterTypesData(genericFilterTypes?.data?.getGenericFilterTypes);
        const genericFilterData = await getGenericFilters({
          variables: {
            filterName: genericFilterTypes?.data?.getGenericFilterTypes?.filter(
              item => item?.code === "VEHICLE_INVENTORY_FILTER"
            )[0]?.name,
            genericFilterTypeId: genericFilterTypes?.data?.getGenericFilterTypes?.filter(
              item => item?.code === "VEHICLE_INVENTORY_FILTER"
            )[0]?.id,
          },
        });
        if (!genericFilterData?.data?.getGenericFilters?.length) {
          const updatedLocations = temp.map(loc =>
            +loc.id === +sessionStorage.getItem("currentLocationId")
              ? { ...loc, isChecked: !loc.isChecked }
              : loc
          );
          setSelectedLocations(updatedLocations);
          await createGenericFilter({
            variables: {
              filterJson: JSON.stringify(updatedLocations),
              filterName: genericFilterTypes?.data?.getGenericFilterTypes?.filter(
                item => item?.code === "VEHICLE_INVENTORY_FILTER"
              )[0]?.name,
              genericFilterTypeId: genericFilterTypes?.data?.getGenericFilterTypes?.filter(
                item => item?.code === "VEHICLE_INVENTORY_FILTER"
              )[0]?.id,
            },
            onCompleted: res => {
              if (res?.createGenericFilter?.statusCode) {
                setSelectedLocations(
                  JSON.parse(
                    res?.createGenericFilter?.genericFilters?.genericFilterJson?.filterJson
                  )
                );
                seGenericFilterDataValues(res?.createGenericFilter?.genericFilters);
              }
            },
          });
        } else {
          setSelectedLocations(
            JSON.parse(genericFilterData?.data?.getGenericFilters[0]?.genericFilterJson?.filterJson)
          );
          seGenericFilterDataValues(genericFilterData?.data?.getGenericFilters[0]);
        }
      }
    },
  });
  const handleAddKeyword = keyword => {
    if (textMode === "Email") {
      handleInsertLink(keyword);
    } else {
      const ctl = document.getElementById("text");
      const startPos = ctl.selectionStart;

      text.current.value = [
        text.current.value.slice(0, startPos),
        `${keyword} `,
        text.current.value.slice(startPos),
      ].join("");
      if (text.current) {
        text.current.focus();
        text.current.style.height = "inherit";
        text.current.style.height = `${text.current.scrollHeight}px`;
      }
      setmessageText(text.current.value);
    }
  };

  const handleVisibleChange = flag => {
    setDropdownVisible(flag);
  };

  const handleMenuClick = e => {
    let updatedLocations = [];
    if (+e.key === 0) {
      updatedLocations = selectedLocations.map(loc => ({
        ...loc,
        isChecked:
          +loc.id === +sessionStorage.getItem("currentLocationId")
            ? true
            : !selectedLocations?.filter(item => +item?.id === +e.key)[0]?.isChecked,
      }));
    } else {
      updatedLocations = selectedLocations.map(loc =>
        +loc.id === +e.key ? { ...loc, isChecked: !loc.isChecked } : loc
      );
    }
    if (updatedLocations?.filter(item => +item?.id !== 0)?.every(data => data.isChecked === true)) {
      updatedLocations = updatedLocations?.map(item => ({
        ...item,
        isChecked: true,
      }));
    } else {
      updatedLocations = updatedLocations?.map(item => {
        if (+item?.id !== 0) return item;
        return {
          ...item,
          isChecked: false,
        };
      });
    }
    updateGenericFilter({
      variables: {
        filterJson: JSON.stringify(updatedLocations),
        filterName: genericFilterTypesData?.filter(
          item => item?.code === "VEHICLE_INVENTORY_FILTER"
        )[0]?.name,
        genericFilterTypeId: genericFilterDataValues?.genericFilterTypeId,
        id: genericFilterDataValues?.id,
      },
    });
    setSelectedLocations(updatedLocations);
  };

  const handleSearchChange = e => {
    setSearchText(e.target.value.toLowerCase());
  };

  const filteredLocations = selectedLocations.filter(loc =>
    loc.title.toLowerCase().includes(searchText)
  );

  const menu = (
    <div className="max-h-64 overflow-y-auto">
      <Menu onClick={handleMenuClick}>
        <Menu.Item key="search">
          <Input
            placeholder="Search locations"
            value={searchText}
            onChange={handleSearchChange}
            className="mb-2"
          />
        </Menu.Item>
        {filteredLocations.map(loc => (
          <Menu.Item key={loc.id}>
            <Checkbox
              disabled={+loc.id === +sessionStorage.getItem("currentLocationId")}
              checked={loc.isChecked}
              className="mr-2"
            />
            {loc.title}
          </Menu.Item>
        ))}
      </Menu>
    </div>
  );

  const [createVdpLinks, { loading: vdpLinkLoader }] = useMutation(CREATE_VDP_LINK_INVENTORY);
  const parseLink = async () => {
    const res = await createVdpLinks({
      variables: {
        locationId: sessionStorage.getItem("currentLocationId"),
        vehicleIds: selectedVehicle.map(item => +item),
      },
    });
    if (res.data.createVdpLinksVehicleInventory.statusCode === 200) {
      message.success(res?.data?.createVdpLinksVehicleInventory?.message);
      const fullString = res?.data?.createVdpLinksVehicleInventory?.vdpLinks.join("\n");
      return fullString;
    }
    message.error(res?.data?.createVdpLinksVehicleInventory?.message);
  };
  const getVinLink = item => {
    let inventoryLink = "";
    if (item?.vdpUrl && !isEmpty(item?.vdpUrl)) {
      inventoryLink = item?.vdpUrl;
    } else if (
      item?.location?.inventoryUrlFormat &&
      item?.location?.inventoryUrlFormat !== "" &&
      item?.location?.inventoryUrlFormat !== null
    ) {
      const url = item?.location?.inventoryUrlFormat || "";
      const isNewOrUsed = item?.isNew ? "new" : "used";
      inventoryLink = url
        .replace("{vinNumber}", item?.vin)
        .replace("{vehicleUsedOrNew}", isNewOrUsed)
        .replace("{vehicleMake}", item?.make);
    }
    return inventoryLink;
  };

  const formatLocations = selectedLocations => {
    const checkedLocations = selectedLocations.filter(item => item.isChecked);

    if (checkedLocations.length <= 2) {
      return checkedLocations.map(item => item.title).join(", ");
    }
    const displayedLocations = checkedLocations
      .slice(0, 2)
      .map(item => item.title)
      .join(", ");
    const moreCount = checkedLocations.length - 2;
    return `${displayedLocations} and +${moreCount} more`;
  };

  const count = vdpData?.getVehicleInventoryV2?.count || 0;
  const paginationProps = {
    current: pagination.page,
    pageSize: pagination.pageSize,
    total: count || 0,
    showTotal: total => `${lang.total}: ${total} ${lang.vehicles}`,
    pageSizeOptions: ["25", "50", "100", "150", "200", "500"],
    showSizeChanger: true,
    onChange: (page, pageSize) => {
      setPagination({ page, pageSize });
    },
    onShowSizeChange: (current, size) => {
      setPagination({ page: current, pageSize: size });
    },
  };
  return (
    <div>
      <div className="flex items-center space-x-2 p-2">
        <Dropdown
          overlay={menu}
          trigger={["click"]}
          visible={dropdownVisible}
          onVisibleChange={handleVisibleChange}
        >
          <Button className="custom-button">
            <span className="mr-4">Locations ({selectedCount})</span>
            <svg xmlns="http://www.w3.org/2000/svg" width={12} height={8} fill="none">
              <path
                fill="#fff"
                stroke="#94A3B8"
                d="m6 6.205-.354-.353-4.499-4.5a.208.208 0 1 0-.295.295l5 5-.353.354.354-.354a.208.208 0 0 0 .294 0l.354.354-.354-.354 5-5a.208.208 0 0 0 0-.294M6 6.205l5.147-4.853M6 6.205l.353-.353 4.5-4.5M6 6.206l4.852-4.852m.295 0a.208.208 0 0 0-.295 0m.295 0h-.295"
              />
            </svg>
          </Button>
        </Dropdown>

        <Input
          className="w-full"
          placeholder="Search by vehicle name"
          suffix={
            <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none">
              <path
                fill="#64748B"
                stroke="#94A3B8"
                strokeWidth={0.078}
                d="m13 12.122-.022.027.025.026 3.912 3.91a.585.585 0 1 1-.83.83l-3.91-3.912-.026-.025-.027.023a6.844 6.844 0 1 1 .879-.879ZM2.087 7.75a5.67 5.67 0 0 0 5.664 5.664A5.664 5.664 0 1 0 2.086 7.75Z"
              />
            </svg>
          }
          value={search}
          onChange={e => setsearch(e.target.value)}
        />
      </div>
      <div className="p-2">
        <span className="text-[#334155] text-xs">
          Showing results for:{" "}
          {selectedLocations?.every(item => item.isChecked === true)
            ? "All"
            : formatLocations(selectedLocations)}
        </span>
      </div>
      <List
        loading={vdpLoader || allLocationLoader || genericFilterLoader || genericFilterTypeLoader}
        className="mt-2 max-h-[300px] overflow-y-scroll vdp-scrollbar-hide"
        dataSource={vdpData?.getVehicleInventoryV2?.data || []}
        renderItem={(item, index) => {
          return (
            <div
              key={index}
              onClick={() =>
                setselectedVehicle(prevSelected => {
                  // Check if the maximum selection limit (3) has been reached
                  if (prevSelected.length >= 3) {
                    // If the limit is reached and the item is already selected, remove it
                    if (prevSelected.includes(item.id)) {
                      return prevSelected.filter(id => id !== item.id);
                    }
                    // If the limit is reached and the item is not selected, return the current selection
                    return prevSelected;
                  }
                  // If the maximum selection limit has not been reached, toggle the item as before
                  if (prevSelected.includes(item.id)) {
                    return prevSelected.filter(id => id !== item.id);
                  }
                  return [...prevSelected, item.id];
                })
              }
              className={`flex flex-row p-2 gap-3 mr-4 mb-4 cursor-pointer ${
                selectedVehicle.includes(item.id)
                  ? "border-solid border-[2px] border-brand-300 bg-brand-100"
                  : ""
              }`}
            >
              <Image.PreviewGroup
                items={(item?.vehicleInventoryMedias || []).map(media => media.mediaUrl)}
              >
                <Image
                  onClick={e => e.stopPropagation()}
                  placeholder={<Skeleton active />}
                  fallback="https://funnel-webapp-uploads.s3.amazonaws.com/prod/images/generic-car-not-available-image.png"
                  className="h-auto w-[100px] rounded-[15px]"
                  src={(item?.vehicleInventoryMedias || [])[0]?.mediaUrl || ""}
                  alt="Vehicle"
                />
              </Image.PreviewGroup>
              <div className="flex flex-col gap-3 ml-4 w-full">
                <div className="flex flex-col gap-1 w-full">
                  <div className="flex flex-row items-center justify-between w-full">
                    <span
                      // href={getVinLink(item)}
                      className="text-sm font-bold"
                      // onClick={e => e.stopPropagation()}
                    >
                      {getHighlightedText(
                        `${item?.year === 0 || isUndefined(item?.year) ? "" : item?.year} ${
                          isEmpty(item?.make) ? "" : item?.make
                        } ${isEmpty(item?.model) ? "" : item?.model} ${
                          isEmpty(item?.trim) ? "" : item?.trim
                        }`,
                        search
                      )}{" "}
                    </span>
                    <Tooltip title="Open inventory">
                      <LinkOutlined
                        onClick={e => {
                          e.stopPropagation();
                          window.open(getVinLink(item));
                        }}
                        className="text-blue-500"
                      />
                    </Tooltip>
                  </div>
                  <span className="text-sm text-grey-700">
                    <span className="font-semibold">MSRP</span>{" "}
                    {item?.msrp || item?.sellingPrice
                      ? `${
                          currencies?.find(currency => currency.code === item.currencyUnit)?.symbol
                        } ${formatPrice(item?.msrp || item?.sellingPrice) || "N/A"}`
                      : "Price not available"}
                  </span>
                  <div className="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width={10} height={14} fill="none">
                      <path
                        fill="#334155"
                        d="M5 3.5a2.187 2.187 0 1 0 0 4.375A2.187 2.187 0 0 0 5 3.5ZM5 7a1.313 1.313 0 1 1 0-2.625A1.313 1.313 0 0 1 5 7ZM5 .875A4.818 4.818 0 0 0 .187 5.688c0 1.717.794 3.537 2.297 5.263.676.78 1.436 1.483 2.267 2.095a.438.438 0 0 0 .502 0 13.9 13.9 0 0 0 2.263-2.095c1.5-1.726 2.296-3.546 2.296-5.264A4.818 4.818 0 0 0 5 .875Zm0 11.266c-.904-.711-3.938-3.323-3.938-6.454a3.937 3.937 0 1 1 7.875 0c0 3.13-3.033 5.743-3.937 6.454Z"
                      />
                    </svg>
                    <span className="ml-2 text-grey-700">
                      {selectedLocations?.map(data => {
                        if (+data?.id === +item?.locationId) {
                          return data?.title;
                        }
                      })}
                    </span>
                  </div>
                </div>
                <div className="flex flex-col font-[400] gap-1">
                  <span className="text-sm text-grey-700">
                    <span className="font-semibold">VIN</span>
                    <span className="absolute left-[45%]">
                      {getHighlightedText(item?.vin || "VIN N/A", search)}
                    </span>
                  </span>
                  <span className="text-sm text-grey-700">
                    <span className="font-semibold">Stock No</span>{" "}
                    <span className="absolute left-[45%]">
                      {getHighlightedText(item?.stockNumber || "N/A", search)}
                    </span>
                  </span>
                  <span className="text-sm text-grey-700">
                    <span className="font-semibold">Model No</span>{" "}
                    <span className="absolute left-[45%]">
                      {getHighlightedText(item?.modelNumber || "N/A", search)}
                    </span>
                  </span>
                  <span className="text-sm text-grey-700">
                    <span className="font-semibold">Color</span>{" "}
                    <span className="absolute left-[45%]">
                      {getHighlightedText(item?.exteriorColor || "N/A", search)}
                      <strong>(E)</strong>
                      {", "}
                      {getHighlightedText(item?.interiorColor || "N/A", search)}
                      <strong>(I)</strong>
                    </span>
                  </span>
                </div>
              </div>
            </div>
          );
        }}
        pagination={null}
        itemLayout="horizontal"
      />
      <div className="p-2">
        <Pagination size="small" {...paginationProps} />
      </div>
      <DialogFooter
        loading={vdpLinkLoader}
        confirmBtnText={selectedVehicle.length > 1 ? "Add Vehicles" : "Add Vehicle"}
        handleCancel={() => closeDialog("vdpSelect")}
        handleConfirm={async () => {
          handleAddKeyword(await parseLink());
          closeDialog("vdpSelect");
        }}
        align="left"
        disabled={selectedVehicle.length === 0 || !selectedVehicle}
      />
      <style jsx>{`
        /* For Webkit-based browsers (Chrome, Safari and Opera) */
        .vdp-scrollbar-hide::-webkit-scrollbar {
          display: none;
        }

        /* For IE, Edge and Firefox */
        .vdp-scrollbar-hide {
          -ms-overflow-style: none; /* IE and Edge */
          scrollbar-width: none; /* Firefox */
        }
      `}</style>
    </div>
  );
}
